$(document).on("turbo:load", () => {
  $('#covid_test_claim_submission_num_of_tests').on('change keyup', (event) => {
    $('#num-of-tests-overlay').show();
    if ($('#covid_test_claim_submission_num_of_tests').val() === "1") {
      $('#num-of-tests-overlay').text("test");
    } else if ($('#covid_test_claim_submission_num_of_tests').val() === "") {
      $('#num-of-tests-overlay').text("");
    } else {
      $('#num-of-tests-overlay').text("tests");
    }

    if ($('#covid_test_claim_submission_num_of_tests').val() >= 10) {
      $('#num-of-tests-overlay').css("left", "38px");
    } else {
      $('#num-of-tests-overlay').css({
        "left": "30px",
        "top": "16px"
      });
    }
  });

  $('#covid_test_claim_submission_total_amount').on('focus', (event) => {
    $('#total-amount-overlay').show();
    $('#covid_test_claim_submission_total_amount').css("width", "calc(100% - 27px)");
    $('#covid_test_claim_submission_total_amount').css("padding-left", "27px");
    if ($('#covid_test_claim_submission_total_amount').val() === "") {
      $('#covid_test_claim_submission_total_amount').val("0.00");
    }
  });

  $('#covid_test_claim_submission_total_amount').on('focus', (event) => {
    var v = $('#covid_test_claim_submission_total_amount').val();
    $('#covid_test_claim_submission_total_amount').data("prev-val", v);
  });

  $('#covid_test_claim_submission_total_amount').on('change keyup', (event) => {
    $('#total-amount-overlay').show();
    $('#covid_test_claim_submission_total_amount').css("width", "calc(100% - 27px)");
    $('#covid_test_claim_submission_total_amount').css("padding-left", "27px");
    var prev_val = $('#covid_test_claim_submission_total_amount').data("prev-val");
    var new_val = $('#covid_test_claim_submission_total_amount').val();

    // check to see if we added digits or removed digits, first
    if (prev_val.toString().length > new_val.toString().length) {
      // we removed digits, so we need to back OFF our calc
      // take the new_val and divide by 10
      new_val = (new_val / 10).toFixed(2);
    } else if (prev_val.toString().length < new_val.toString().length) {
      // we added digits, so we need to add to our calc
      // we already have a value in here, so multiply ny 1000 to get cents, then divide back down by 100 to get correct dollars and cents
      new_val = (new_val * 1000 / 100).toFixed(2);
    }
    
    $('#covid_test_claim_submission_total_amount').val(new_val);
    $('#covid_test_claim_submission_total_amount').data("prev-val", new_val);
  });

  $('#confirm-share-copy-btn').on("click", (event) => {
    navigator.clipboard.writeText($('#confirm-share-text').text());
    $('#confirm-share-copy-btn').text("COPIED!");
  })

  $('.date-month-field, .date-day-field, .date-year-field').on('focus', (event) => {
    $('.date-fields-container').css("border", "2px solid #5660FB");
  });

  $('.date-month-field, .date-day-field, .date-year-field').on('blur', (event) => {
    $('.date-fields-container').css("border", "2px solid #fff");
  });

  $('#purchased_at_month, #purchased_at_year, #purchased_at_day').on('keyup change', (event) => {
    if (
      $('#purchased_at_month').val().length
      && $('#purchased_at_day').val().length
      && $('#purchased_at_year').val().length === 4
    ) {
      var d = new Date($('#purchased_at_year').val() + "-" + $('#purchased_at_month').val() + "-" + $('#purchased_at_day').val());
      var jan15 = new Date("2022-01-15");

      if (!(d.toString() === jan15.toString() || d > jan15)) {
        $('#ctcs-other-info-btn').prop("disabled", true);
        $('#ineligible-purchased-at-container').show();
      } else {
        $('#ctcs-other-info-btn').prop("disabled", false);
        $('#ineligible-purchased-at-container').hide();
      }
    }
  });
});